export const nextParam = (location: { pathname: string; search: string }): string => {
  const here = `${location.pathname}${location.search}`;
  if (here === "/" || here.startsWith("/login") || here.startsWith("/signup")) return "";
  return `?next=${encodeURIComponent(here)}`;
};

export const forwardNext = (search: string): string => {
  const next = new URLSearchParams(search).get("next");
  return next ? `?next=${encodeURIComponent(next)}` : "";
};
